<template>
  <button class="button is-black skip-to-main" href="" @click="skipToMain">
    Skip to content
  </button>
</template>
<style scoped lang="scss">
.skip-to-main {
  left: 50%;
  position: absolute;
  transform: translateY(-100%);
  transition: transform 0.3s;
  z-index: 40;

  &:focus {
    transform: translateY(0%);
  }
}
</style>
<script>
export default {
  methods: {
    skipToMain() {
      document.getElementById("main").focus();
    }
  }
};
</script>
